import { ImageZoomService } from "./../shared/image-zoom/image-zoom.service";
import { environment } from "./../../environments/environment";
import { LeadsService } from "./../services/lead-service/lead-service.service";
import { ErrorHandlerService } from "./../services/shared/error-handler.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { Component, OnInit, ViewContainerRef } from "@angular/core";
import { ProjectsService } from "../services/projects/projects.service";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import * as _ from "lodash";
import { Lightbox } from "ngx-lightbox";

import swal from "sweetalert2";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AccountsService } from "../services/settings-service/accounts/accounts.service";

@Component({
  selector: "projects",
  templateUrl: "./projects.component.html",
  styleUrls: [
    "../../assets/css/style.css",
    "../../assets/css/custom.css",
    "./projects.component.css",
  ],
  providers: [ProjectsService],
})
export class ProjectsComponent implements OnInit {
  pagination: any = [];
  projectUnits: any = [];
  totalRec: number;
  projects: Array<any> = [];
  userData: any = JSON.parse(window.localStorage.getItem("userProfile"));
  next_page_url: any;
  prev_page_url: any;
  current_page: any;
  private _staticMasterPlanImages: Array<any> = [];
  filesForm: FormGroup;
  allowedRoles: string[] = [];
  isRoleAllowed: boolean;

  constructor(
    private projectService: ProjectsService,
    private accountService: AccountsService,
    private router: Router,
    private slimLoadingBarService: SlimLoadingBarService,
    public errorHandlerService: ErrorHandlerService,
    public leadsService: LeadsService,
    private _lightbox: Lightbox,
    private formBuilder: FormBuilder,
    private imageZoomService: ImageZoomService
  ) {
    this.getprojects();
    this.filesForm = this.formBuilder.group({
      file_name: [null, Validators.required],
      file: [null, Validators.required],
    });
  }

  ngOnInit() {
    this.getAllowedRoles();
  }

  getAllowedRoles() {
    this.accountService.getMortageControlsRoles().subscribe(
      (data: any) => {
        this.allowedRoles = data.allowedRoles;
        let role = this.userData.role;
        this.isRoleAllowed = this.allowedRoles.includes(role);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  handleComissionExcel(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      console.log(file);
      reader.onload = () => {
        this.filesForm.get("file_name").setValue(file.name);
        this.filesForm
          .get("file")
          .setValue((reader.result as any).split(",")[1]);
      };
    }
  }

  submitComissionModal(project_id, modal) {
    let payload = this.filesForm.value;
    modal.close();
    console.log(payload);
    this.slimLoadingBarService.start();
    this.leadsService.uploadComissionPerProject(project_id, payload).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        swal(
          "success",
          "uploaded comisssion for this project successfully",
          "success"
        );
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.reset();
      }
    );
  }

  downloadComissionSheet(project_id) {
    this.slimLoadingBarService.start();
    this.leadsService.downloadComissionPerProject(project_id).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        window.open(res.url);
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.reset();
      }
    );
  }

  downloadAvailableSheet(project_id) {
    this.slimLoadingBarService.start();
    this.projectService
      .filterUnits(project_id, {
        is_export: 1,
        status: "Available",
      })
      .subscribe(
        (res: any) => {
          this.slimLoadingBarService.complete();
          window.open(res.url);
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.reset();
        }
      );
  }

  downloadFile(url) {
    window.open(url);
  }
  getprojects() {
    this.projects = null;
    this.slimLoadingBarService.start(() => {
      console.log("Loading complete");
    });
    this.projectService.getProjects().subscribe(
      (data) => {
        this.pagination = [];
        this.next_page_url = data.next_page_url;
        this.current_page = 1;
        let selected = true;
        for (var i = 1; i <= data.last_page; i++) {
          if (i > 1) selected = false;
          this.pagination.push({ number: i, selected: selected });
          console.log(i);
        }
        console.log(this.pagination);
        this.totalRec = data.total;
        this.projects = data.data;
        this.projects.forEach((project, x) => {
          this.projects[x].excel = `${environment.api_base_url}units/export/${
            project.id
          }?token=${window.localStorage.getItem("token")}`;
          project.unit_types = _.values(project.unit_types);
        });
        console.log(this.projects);
        this.slimLoadingBarService.complete();
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  openGallery(images, index) {
    this._staticMasterPlanImages = [];
    for (let i = 0; i < images.length; i++) {
      const src = images[i].image.url;
      const caption = " ";
      const thumb = images[i].image.url;
      const album = {
        src: src,
        caption: caption,
        thumb: thumb,
      };
      this._staticMasterPlanImages.push(album);
    }
    console.log(this._staticMasterPlanImages);
    this._lightbox.open(this._staticMasterPlanImages, index);
  }

  printImg(src) {
    this.projectService.printImg(src);
  }

  infinite(url) {
    this.leadsService.infinit(url).subscribe(
      (data: any) => {
        this.projectUnits = data.data;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  paginate(number) {
    this.pagination.forEach((element) => {
      if (element.number == number) {
        element.selected = true;
        // console.log('matched');
        // if(number > )
        // console.log(this.next_page_url);
        let arr = this.next_page_url.split("?");
        // console.log(this.current_page);
        // console.log(number);
        if (this.current_page != number) {
          let selectedUrl = `${arr[0]}?page=${number}`;
          console.log(selectedUrl);
          this.current_page = number;
          this.infinite(selectedUrl);
        }
        // console.log(arr);
      } else element.selected = false;
    });
  }

  getProjectUnitsbytype(project_id, unit_type_id) {
    this.router.navigate(["/pages/projects/units/", project_id], { queryParams: { unit_type_id: unit_type_id } });
  }

  openMasterPlanZoom(img) {
    this.imageZoomService.open(img);
  }

  setupModeMasterPlan(id) {
    this.router.navigate(["/pages/master-plan"], {
      queryParams: { mode: "setup", id: id },
    });
  }

  staticMasterPlanImagesModalModalOpen() {}

  staticMasterPlanImagesModalClose() {}

  staticMasterPlanImagesModalSubmit(modal) {
    // let payload = {
    //   is_overseas: this.is_overseas
    // };
    // this.slimLoadingBarService.start();
    // this.reservationService
    //   .changeOverseas(this.reservation_details.id, payload)
    //   .subscribe(
    //     (res: any) => {
    //       this.getReservation();
    //       modal.close();
    //     },
    //     err => this.errorHandlerService.handleErorr(err),
    //     () => this.slimLoadingBarService.complete()
    //   );
  }

  openExcel(url) {
    window.open(url);
  }

  deleteBtn(img, projectIndex, index) {
    console.log(img, index);
    swal({
      title: "Are you sure?",
      text: "You will delete this masterplan!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, detele it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.projectService.deleteStaticMasterPlan(img.id).subscribe(
          (data) => {
            this.projects[projectIndex].static_master_plan.splice(index, 1);
            swal("Woohoo!", "Deleted this masterplan!", "success");
            this.slimLoadingBarService.complete();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.complete();
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  goToBulkCalculator(id: number) {
    // this.router.navigate(["/projects/project-bulk-calculator", id]);
    this.router.navigateByUrl(
      `/pages/project-bulk-calculator?project_id=${id}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/projects.component.ts